import React, { useState } from "react";
import LongFormDialog from "../../../../components/Dialog/LongFormDialog";
import SurveyIcon from "../../../../styles/svg/survey-download.svg";
import ViewFile from "../../../../components/ViewFile";
import toast from "react-hot-toast";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { downloadLl55SurveyForm } from "../../../../sevices/ll55Api";
import DownloadLl55SurveyCompliance from "./DownloadLl55SurveyCompliance";

function ViewSurvey({ params }) {
  const [anchorEl, setAnchorEl] = useState(false);
  const [url, setUrl] = useState("");
  const [year] = useCustomSearchParams("year");

  const handleClose = () => {
    setAnchorEl(false);
  };
  const handleClick = () => {
    setAnchorEl(true);
  };
  const downloadMailer = () => {
    // setLoading(true);
    downloadLl55SurveyForm({
      year: year,
      ll55_id: params.row?.compliance?.ll55_id,
    })
      .then((res) => {
        setUrl({
          url: `/ll55/report/${res.data.pdf_file_path}`,
        });
        handleClick();
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message);
      });
  };

  return (
    <>
      {anchorEl && (
        <LongFormDialog
          open={anchorEl}
          handleClose={handleClose}
          title={"Survey Response"}
          btnTitle={"Confirm"}
          IsChildren={
            <DownloadLl55SurveyCompliance
              complianceId={params.row?.compliance?.ll55_id}
            />
          }
        >
          <ViewFile url={url.url} />
        </LongFormDialog>
      )}
      <div>
        {params.row?.compliance?.status != "pending" &&
          params.row?.compliance?.status && (
            <img
              src={SurveyIcon}
              onClick={downloadMailer}
              className="cursor-pointer"
            />
          )}
      </div>
    </>
  );
}

export default ViewSurvey;